// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************GET PORTFOLIO REPORT START ************* */
export const PortfolioReportDetailsGet = (fetchData: any) => {
	const data = {
		GetPortfolioReportToken: fetchData,
	};
	const url = `${API_URL}PostPortfolioReport`;
	return makeApiCall(url, data);
};
/** ***************GET PORTFOLIO REPORT END ************* */
